import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { Route, RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const RedirectLegacyViewPageLoader: LoadableType<Route & RouteMatch> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RedirectLegacyViewPage" */ './RedirectLegacyViewPage.tsx'
			)
		).RedirectLegacyViewPage,
});

(RedirectLegacyViewPageLoader as any).NAVIGATION_PARAMS = () => false;
